<template>
  <form accept-charset="UTF-8" role="form" id="contact-form" class="contact-form">
    <div class="form-group">
      <label for="contact-name" ref="contact-name" class="contact-form__label">Nome</label>

      <input
        type="text"
        name="name"
        v-model="contact.name"
        v-validate="'required'"
        ref="contact-name"
        class="form-control"
        :class="{'error': errors.has('name')}"
        id="contact-name"
        autocomplete="off"
        autocorrect="off"
      />

      <span class="vee-error">{{errors.first('name')}}</span>
    </div>

    <div class="form-group">
      <label for="contact-email" ref="contact-email" class="contact-form__label">Email</label>

      <input
        type="email"
        name="email"
        v-model="contact.email"
        v-validate="'required|email'"
        ref="contact-email"
        class="form-control"
        :class="{'error': errors.has('email')}"
        id="contact-email"
        autocapitalize="off"
        autocomplete="off"
        autocorrect="off"
      />

      <span class="vee-error">{{errors.first('email')}}</span>
    </div>

    <div class="form-group">
      <label for="contact-phone" ref="contact-phone" class="contact-form__label">Telefone</label>

      <input
        type="tel"
        name="phone"
        v-model="contact.phone"
        v-mask="['(##) ####-####', '(##) #####-####']"
        v-validate="'required'"
        ref="contact-email"
        class="form-control"
        :class="{'error': errors.has('phone')}"
        id="contact-phone"
      />
    </div>

    <div class="form-group">
      <label for="contact-message" ref="contact-message" class="contact-form__label">Mensagem</label>

      <textarea
        name="message"
        v-model="contact.message"
        v-validate="'required'"
        ref="contact-message"
        cols="50"
        rows="10"
        class="form-control"
        :class="{'error': errors.has('message')}"
        id="contact-message"
      ></textarea>

      <span class="vee-error">{{errors.first('message')}}</span>
    </div>

    <btn-send :sending-form="sendingForm" />
  </form>
</template>

<script>
import BtnSend from "./BtnSend.vue";
import api from "../support/api";

export default {
  components: {
    BtnSend
  },

  data() {
    return {
      sendingForm: false,

      contact: {
        name: "",
        email: "",
        phone: "",
        message: "",

        gRecaptchaResponse: ""
      }
    };
  },

  created() {
    bus.$on("validateContactForm", () => {
      this.validateBeforeSubmit();
    });
  },

  methods: {
    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.recaptcha();
        } else {
          return this.scrollToFirstError();
        }
      });
    },

    scrollToFirstError() {
      const firstField = Object.keys(this.errors.collect())[0];
      this.$refs[`contact-${firstField}`].scrollIntoView();
    },

    recaptcha() {
      let vm = this;

      grecaptcha.ready(function() {
        grecaptcha
          .execute("6Lc4BcEUAAAAAMokAY9PI4B3wzWqOpDIN6ecbz5J", {
            action: "contact"
          })
          .then(function(token) {
            vm.contact.gRecaptchaResponse = token;
            api.postContact(vm);
          });
      });
    }
  }
};
</script>
